import { ConfigProvider } from "antd";
import Header from "components/Header";
import { useState } from "react";
import { colorFormat } from "utils/format/ColorFormat";
import Sidebar from "../Sidebar";

function Main({ children, history, info }: any) {
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: colorFormat?.Blue,
          colorError: colorFormat?.Red_Dark,
        },
        components: {
          Menu: {
            itemColor: colorFormat?.Black,
            itemBg: "transparent",
            subMenuItemBg: "transparent",
            itemSelectedColor: colorFormat?.Blue,
            itemSelectedBg: "transparent",
            itemActiveBg: "transparent",
          },
        },
      }}
    >
      <div className="flex h-screen overflow-hidden">
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        <div className="relative flex flex-col flex-1 overflow-y-auto">
          <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
          <section>{children}</section>
        </div>
      </div>
    </ConfigProvider>
  );
}

export default Main;
